<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '400px' }"
  [styleClass]="'message-dialog'"
  (onHide)="closeDialog()"
>
  <!-- Title -->
  <div class="text-center py-4">
    <div
      class="h4 fw-bold"
      [class]="titleClass"
    >
      {{ title }}
    </div>
  </div>

  <!-- Message -->
  <div class="text-center py-3 px-3">
    <div class="text-muted">{{ message }}</div>
  </div>

  <ng-template pTemplate="footer">
    <hr />
    <div class="d-flex justify-content-center pb-3">
      <button
        class="btn btn-primary"
        (click)="closeDialog()"
      >
        Close
      </button>
    </div>
  </ng-template>
</p-dialog>
